import { X } from "lucide-react";

const TITLES = { cart: "Your Cart", form: "Checkout", done: "Order Confirmed" };
export const CartHeader = ({ step, close }) => (
  <div className="flex items-center justify-between border-b border-line px-6 py-5">
    <p className="font-display text-sm font-bold uppercase tracking-[0.2em]" data-testid="cart-step-title">{TITLES[step]}</p>
    <button onClick={close} aria-label="Close cart" data-testid="cart-close-button" className="grid h-10 w-10 place-items-center border border-line text-neutral-300 hover:border-regal-amber hover:text-regal-amber transition-colors"><X size={18} /></button>
  </div>
);